import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ownerDocument from '../../utils/ownerDocument';
import addEventListener from '../../utils/addEventListener';
import classNames from 'classnames';
var Resizer = /*#__PURE__*/function (_Component) {
  _inherits(Resizer, _Component);
  var _super = _createSuper(Resizer);
  function Resizer(props) {
    var _this;
    _classCallCheck(this, Resizer);
    _this = _super.call(this, props);
    _this.state = {
      isDrag: false,
      startPos: {
        x: 0,
        y: 0
      }
    };
    _this.handleMove = _this.handleMove.bind(_assertThisInitialized(_this));
    _this.handleStart = _this.handleStart.bind(_assertThisInitialized(_this));
    _this.handleEnd = _this.handleEnd.bind(_assertThisInitialized(_this));
    _this.listeners = function () {
      var doc = ownerDocument(_assertThisInitialized(_this));
      var mouseUpListener = addEventListener(doc, 'mouseup', _this.handleEnd);
      var mouseMoveListener = addEventListener(doc, 'mousemove', _this.handleMove);
      var touchEndListener = addEventListener(doc, 'touchend', _this.handleEnd);
      var touchMoveListener = addEventListener(doc, 'touchmove', _this.handleMove);
      return {
        remove: function remove() {
          mouseUpListener.remove();
          mouseMoveListener.remove();
          touchEndListener.remove();
          touchMoveListener.remove();
        }
      };
    };
    return _this;
  }
  _createClass(Resizer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: "isTouch",
    value: function isTouch(event) {
      return event.type === 'touchstart' || event.type === 'touchmove';
    }
  }, {
    key: "getClientX",
    value: function getClientX(event) {
      return this.isTouch(event) ? event.touches[0].clientX : event.clientX;
    }
  }, {
    key: "getClientY",
    value: function getClientY(event) {
      return this.isTouch(event) ? event.touches[0].clientY : event.clientY;
    }
  }, {
    key: "handleMove",
    value: function handleMove(event) {
      event.preventDefault();
      if (!this.state.isDrag) {
        return;
      }
      var _this$props = this.props,
        direction = _this$props.direction,
        onResize = _this$props.onResize;
      if (direction === Resizer.HORIZONTAL) {
        var diff = this.state.startPos.x - this.getClientX(event);
        if (diff !== 0) {
          onResize(diff);
        }
      }
      if (direction === Resizer.VERTICAL) {
        var _diff = this.state.startPos.y - this.getClientY(event);
        if (_diff !== 0) {
          onResize(_diff);
        }
      }
      this.updateStartPosition(event);
    }
  }, {
    key: "handleStart",
    value: function handleStart(event) {
      event.preventDefault();
      this.setState({
        isDrag: true,
        startPos: this.getStartPos(event)
      });
      this.props.onResizeStart(event);
      this.events = this.listeners();
    }
  }, {
    key: "handleEnd",
    value: function handleEnd(event) {
      this.setState({
        isDrag: false
      });
      this.props.onResizeEnd(event);
      this.removeListeners();
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (this.events) {
        this.events.remove();
      }
    }
  }, {
    key: "updateStartPosition",
    value: function updateStartPosition(event) {
      this.setState({
        startPos: this.getStartPos(event)
      });
    }
  }, {
    key: "getStartPos",
    value: function getStartPos(event) {
      return {
        x: this.getClientX(event),
        y: this.getClientY(event)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        direction = _this$props2.direction,
        position = _this$props2.position,
        children = _this$props2.children;
      var wrapperClasses = classNames('Resizer', direction === Resizer.HORIZONTAL && 'resize-horizontal', direction === Resizer.VERTICAL && 'resize-vertical', position === Resizer.LEFT && 'resize-left', position === Resizer.RIGHT && 'resize-right', position === Resizer.TOP && 'resize-top', position === Resizer.BOTTOM && 'resize-bottom', className && className);
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClasses,
        onMouseDown: this.handleStart,
        onMouseMove: this.handleMove,
        onMouseUp: this.handleEnd,
        onTouchStart: this.handleStart,
        onTouchMove: this.handleMove,
        onTouchEnd: this.handleEnd
      }, children && children);
    }
  }]);
  return Resizer;
}(Component);
Resizer.HORIZONTAL = 'x';
Resizer.VERTICAL = 'y';
Resizer.LEFT = 'left';
Resizer.RIGHT = 'right';
Resizer.TOP = 'top';
Resizer.BOTTOM = 'bottom';
Resizer.defaultProps = {
  className: '',
  direction: Resizer.HORIZONTAL,
  position: Resizer.RIGHT,
  onResizeStart: function onResizeStart() {},
  onResize: function onResize() {},
  onResizeEnd: function onResizeEnd() {}
};
Resizer.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf([Resizer.HORIZONTAL, Resizer.VERTICAL]),
  position: PropTypes.oneOf([Resizer.LEFT, Resizer.RIGHT, Resizer.TOP, Resizer.BOTTOM]),
  onResizeStart: PropTypes.func,
  onResize: PropTypes.func.isRequired,
  onResizeEnd: PropTypes.func
};
export default Resizer;